import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    cta: 'Confirm my information',
    labels: {
      assets: 'Your personal wealth in €',
      fiscalResidence:
        'Do you have a tax residence in a country other than France?',
      income: 'Your annual income in €',
      no: 'No',
      usCitizen:
        'Do you have US citizenship or pay taxes in the United States (US\u00A0person)?',
      yes: 'Yes',
    },
    section: 'Financial information',
    title: 'Your financial situation',
  },
  fr: {
    cta: 'Confimer mes informations',
    labels: {
      assets: 'Votre patrimoine personnel en €',
      fiscalResidence:
        'Avez-vous une résidence fiscale dans un autre pays que la France\u00A0?',
      income: 'Votre revenu annuel en €',
      no: 'Non',
      usCitizen:
        'Avez-vous la citoyenneté américaine ou payez-vous des impôts aux États-Unis (US person)\u00A0?',
      yes: 'Oui',
    },
    section: 'Informations fiscales',
    title: 'Votre situation fiscale',
  },
} as const);
